export default {
  "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Organise ta prochaine aventure"])},
  "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nous sommes une <b>communauté</b> qui souhaite rendre la <b>randonnée</b> longue distance accessible à tous."])},
  "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Découvrir les trails"])}
}